var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.583 13.333a1.25 1.25 0 0 0-2.5 0v.017a1.25 1.25 0 0 0 2.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.271 24.604a2.916 2.916 0 1 1 4.125 4.124 2.916 2.916 0 0 1-4.125-4.124m2.062 1.646a.417.417 0 1 0 0 .834.417.417 0 0 0 0-.834",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.333 5.417a2.916 2.916 0 0 0-2.916 2.917v23.333a2.917 2.917 0 0 0 2.916 2.917h10a2.916 2.916 0 0 0 2.917-2.917V8.334a2.917 2.917 0 0 0-2.917-2.917zm-.294 2.622a.42.42 0 0 1 .294-.122h10a.417.417 0 0 1 .417.417v23.333a.417.417 0 0 1-.417.417h-10a.417.417 0 0 1-.416-.417V8.334c0-.11.044-.217.122-.295",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.372 9.705a.42.42 0 0 1 .295-.122h10a1.25 1.25 0 0 0 0-2.5h-10A2.917 2.917 0 0 0 3.75 10v13.333a2.917 2.917 0 0 0 2.917 2.917h7.083v4.167h-2.083a1.25 1.25 0 1 0 0 2.5h5a1.25 1.25 0 0 0 0-2.5h-.417V26.25h.417a1.25 1.25 0 0 0 0-2.5h-10a.416.416 0 0 1-.417-.417V10c0-.11.044-.217.122-.295"
  })));
};
export default SvgComputer;